import { ClosingAccountDispatcher } from "../Stores/Variable";

import { ActionType } from "../../../../react-core/Flux/ActionType";
import { AccountInClosureClient } from "../../../../Wrap/Api/Account/AccountInClosure";

export class AccountInClosuretAction {
    public static getAccountClosureList(accountName: string, accountNum: string, start: number, count: number): void {
        const client = new AccountInClosureClient();
        const promise = client.get(accountNum, accountName, start, count);
        promise.onSuccess((data) => {
            ClosingAccountDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
